import dayjs from 'dayjs';
import pluginDuration from 'dayjs/plugin/duration';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import pluginIsSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(pluginDuration);
dayjs.extend(isSameOrBefore);
dayjs.extend(pluginIsSameOrAfter);
export const MAX_DURATION = 86400000000;
export function getPlaceholder(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) {
        return customizePlaceholder;
    }
    if (picker === 'year' && locale.lang.yearPlaceholder) {
        return locale.lang.yearPlaceholder;
    }
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) {
        return locale.lang.quarterPlaceholder;
    }
    if (picker === 'month' && locale.lang.monthPlaceholder) {
        return locale.lang.monthPlaceholder;
    }
    if (picker === 'week' && locale.lang.weekPlaceholder) {
        return locale.lang.weekPlaceholder;
    }
    if (picker === 'time' && locale.timePickerLocale.placeholder) {
        return locale.timePickerLocale.placeholder;
    }
    return locale.lang.placeholder;
}
export function getRangePlaceholder(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) {
        return customizePlaceholder;
    }
    if (picker === 'year' && locale.lang.yearPlaceholder) {
        return locale.lang.rangeYearPlaceholder;
    }
    if (picker === 'month' && locale.lang.monthPlaceholder) {
        return locale.lang.rangeMonthPlaceholder;
    }
    if (picker === 'week' && locale.lang.weekPlaceholder) {
        return locale.lang.rangeWeekPlaceholder;
    }
    if (picker === 'time' && locale.timePickerLocale.placeholder) {
        return locale.timePickerLocale.rangePlaceholder;
    }
    return locale.lang.rangePlaceholder;
}
export var GlobalPickerType;
(function (GlobalPickerType) {
    GlobalPickerType[GlobalPickerType["shortcut"] = 1] = "shortcut";
    GlobalPickerType[GlobalPickerType["custom"] = 2] = "custom";
    GlobalPickerType[GlobalPickerType["recently"] = 3] = "recently";
    GlobalPickerType[GlobalPickerType["special"] = 4] = "special";
})(GlobalPickerType || (GlobalPickerType = {}));
export function getTargetFromEvent(e) {
    var _a;
    const target = e.target;
    // get target if in shadow dom
    if (e.composed && target.shadowRoot) {
        return (((_a = e.composedPath) === null || _a === void 0 ? void 0 : _a.call(e)[0]) || target);
    }
    return target;
}
export function elementsContains(elements, target) {
    return elements.some(ele => {
        let isContain = false;
        if (ele) {
            // @ts-ignore
            if (ele.input) {
                // @ts-ignore
                isContain = ele.input.contains(target);
            }
            else {
                isContain = ele.contains(target);
            }
        }
        return isContain;
    });
}
let globalClickFunc = null;
const clickCallbacks = new Set();
export function addGlobalMouseDownEvent(callback) {
    if (!globalClickFunc && typeof window !== 'undefined' && window.addEventListener) {
        globalClickFunc = (e) => {
            // Clone a new list to avoid repeat trigger events
            [...clickCallbacks].forEach(queueFunc => {
                queueFunc(e);
            });
        };
        window.addEventListener('mousedown', globalClickFunc);
    }
    clickCallbacks.add(callback);
    return () => {
        clickCallbacks.delete(callback);
        if (clickCallbacks.size === 0) {
            window.removeEventListener('mousedown', globalClickFunc);
            globalClickFunc = null;
        }
    };
}
// =======================
// ===== 全局时间组件 =========
// ========================
// 生成刷新频率
export const generateRefreshOptions = (locale) => [
    { label: locale === null || locale === void 0 ? void 0 : locale.noRefresh, value: 0 },
    { label: `1 ${locale === null || locale === void 0 ? void 0 : locale.minutes}`, value: 60 },
    { label: `3 ${locale === null || locale === void 0 ? void 0 : locale.minutes}`, value: 3 * 60 },
    { label: `5 ${locale === null || locale === void 0 ? void 0 : locale.minutes}`, value: 5 * 60 },
    { label: `15 ${locale === null || locale === void 0 ? void 0 : locale.minutes}`, value: 15 * 60 },
];
export const isAbsoluteTime = (value) => /^\d[\d:-\s]+\d$/.test(value);
export const isRelativeTime = (value) => /-?\d?\/?([Mdhmswy]+?)/.test(value);
export const isSpecialTime = (value) => /%[A-Z_a-z]+%/.test(value);
export const multiSpaceToOne = (value) => value.replace(/\s+/g, ' ');
export function valueToShortcut(value) {
    return {
        type: value.split('~').some(item => isAbsoluteTime(item.trim()))
            ? GlobalPickerType.custom
            : GlobalPickerType.shortcut,
        label: value,
        value,
    };
}
// // 合并时间值与日期值
// export function mergeTimeAndDate(date: Dayjs, time: Dayjs) {
//   return dayjs(date).hour(time.hour()).minute(time.minute()).second(time.second());
// }
// duration单位是毫秒
function generateDuration(duration) {
    const diffTime = dayjs.duration(duration);
    const d = Math.floor(diffTime.asDays());
    const h = diffTime.hours();
    const m = diffTime.minutes();
    const s = diffTime.seconds();
    const ms = diffTime.asMilliseconds();
    return {
        d,
        h,
        m,
        s,
        ms,
    };
}
// 计算开始时间与结束时间之间的长度
export function computedDuration(dates) {
    let res;
    if (dates && dates[0] && dates[1]) {
        res = generateDuration(dates[1].valueOf() - dates[0].valueOf());
    }
    return res;
}
// 计算时间间隔文本
export function durationText(dates, maxDuration, locale) {
    let isGreater = false;
    let isEqual = false;
    let isInvalid = false;
    let formatString = locale === null || locale === void 0 ? void 0 : locale.invalidTimeRange;
    if (dates && dates[0] && dates[1]) {
        if (dates[1].valueOf() - dates[0].valueOf() > maxDuration) {
            isGreater = true;
            const durationObj = generateDuration(maxDuration);
            if (durationObj && locale) {
                isInvalid = false;
                formatString = `${locale === null || locale === void 0 ? void 0 : locale.noGreater} ${durationObj.d > 0 ? `${durationObj.d} ${locale === null || locale === void 0 ? void 0 : locale.day} ` : ''} ${durationObj.h > 0 ? `${durationObj.h} ${locale === null || locale === void 0 ? void 0 : locale.hour} ` : ''} ${durationObj.m > 0 ? `${durationObj.m} ${locale === null || locale === void 0 ? void 0 : locale.minute} ` : ''} ${durationObj.s > 0 ? `${durationObj.s} ${locale === null || locale === void 0 ? void 0 : locale.second}` : ''}`;
            }
        }
        else {
            const durationObj = computedDuration(dates);
            if (durationObj && locale) {
                isInvalid = false;
                formatString = `${durationObj.d > 0 ? `${durationObj.d} ${locale === null || locale === void 0 ? void 0 : locale.day} ` : ''}${durationObj.h > 0 ? `${durationObj.h} ${locale === null || locale === void 0 ? void 0 : locale.hour} ` : ''}${durationObj.m > 0 ? `${durationObj.m} ${locale === null || locale === void 0 ? void 0 : locale.minute} ` : ''}${durationObj.s > 0 ? `${durationObj.s} ${locale === null || locale === void 0 ? void 0 : locale.second}` : ''}`;
                if (!formatString.trim()) {
                    formatString = locale === null || locale === void 0 ? void 0 : locale.noEqual;
                    isEqual = true;
                }
            }
        }
    }
    else {
        isInvalid = true;
    }
    return { isInvalid, isGreater, isEqual, formatString };
}
// 是否是当前时间或当前时间之后
function isSameAfterNow(date) {
    return date && date.startOf('m').isSameOrAfter(dayjs().startOf('m'));
}
// 将dayjs日期值转为value值, dayjs => -2h
function dateToValue(date) {
    if (date) {
        if (isSameAfterNow(date)) {
            return 'now';
        }
        let value = '';
        const duration = computedDuration([date, dayjs()]);
        if (duration) {
            ['y', 'M', 'd', 'h', 'm'].forEach(key => {
                if (duration[key] > 0) {
                    value += `${duration[key]}${key}`;
                }
            });
        }
        return `-${value}`;
    }
    return '';
}
// [dayjs, dayjs] => -2h ~ -1h
export function datesToValue(dates) {
    return (dates === null || dates === void 0 ? void 0 : dates.map(item => dateToValue(item)).join(' ~ ')) || '';
}
// 解析相对单个时间
const parseRelativeTime = (value) => {
    if (!value) {
        return null;
    }
    // 生成actionArr
    const [unitString, originString] = value.split('/');
    let actionArr = [];
    if (unitString && !/\.\d/.test(unitString)) {
        const myRe = /-?(\d+?)([Mdhmswy]+?)/g;
        let match = myRe.exec(unitString);
        // 是否全匹配
        let isAllMatch = true;
        while (match !== null) {
            actionArr.push({
                unit: match[2],
                cycle: Number(match[1]),
                isSubtract: true,
            });
            isAllMatch = match[0].length + match.index === unitString.length;
            match = myRe.exec(unitString);
        }
        if (!isAllMatch) {
            actionArr = [];
        }
    }
    if (originString) {
        actionArr.push({ unit: originString, isStartOf: true });
    }
    // 通过actionArr生成dayjs
    if (actionArr.length) {
        let resultDate = dayjs();
        actionArr.forEach(item => {
            if (item.isSubtract) {
                // @ts-ignore
                resultDate = resultDate.subtract(Number(item.cycle), item.unit);
            }
            else if (item.isStartOf) {
                resultDate = resultDate.startOf(item.unit);
            } /*  */
        });
        return resultDate;
    }
    return null;
};
// 解析单个时间缩写
const parseSingleAbbreviation = (value) => {
    let date = null;
    if (isAbsoluteTime(value)) {
        // 绝对时间
        date = dayjs(value, [
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DD HH:mm',
            'YYYY-MM-DD',
            'YYYY-MM',
            'YYYY HH:mm',
            'YYYY',
            'HH:mm',
        ], true);
        date = isNaN(date.valueOf()) ? null : date;
    }
    else if (isRelativeTime(value)) {
        // 相对时间
        date = parseRelativeTime(value);
    }
    return date;
};
export const parseShortcutValue = (value) => {
    //  不能含有汉字
    if (value && !/[\u4e00-\u9fa5]/.test(value)) {
        // value不包含 ~ now 时补齐
        let mergedValue = value;
        if (!(value === null || value === void 0 ? void 0 : value.includes('now')) && isRelativeTime(value)) {
            mergedValue = `${value} ~ now`;
        }
        const [start, end] = mergedValue.split('~').map(s => s.trim());
        const startDate = parseSingleAbbreviation(start);
        const endDate = end === 'now' ? dayjs() : parseSingleAbbreviation(end);
        return [startDate, endDate];
    }
    return null;
};
// 快捷方式列表
export const computeShortcutOptions = locale => [
    {
        type: GlobalPickerType.shortcut,
        label: locale.liveTail,
        value: 'live',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last5minutes,
        value: '-5m',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last10minutes,
        value: '-10m',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last30minutes,
        value: '-30m',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last1hour,
        value: '-1h',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last3hours,
        value: '-3h',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last6hours,
        value: '-6h',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last12hours,
        value: '-12h',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last24hours,
        value: '-24h',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last2days,
        value: '-2d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last3days,
        value: '-3d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last7days,
        value: '-7d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last30days,
        value: '-30d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last90days,
        value: '-90d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last6months,
        value: '-6M',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.last1year,
        value: '-1y',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.today,
        value: '/d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.yesterday,
        value: '-1d/d ~ /d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.thisDayLastWeek,
        value: '-7d/d ~ -6d/d',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.thisWeek,
        value: '/w',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.previousWeek,
        value: '-1w/w ~ /w',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.thisMonth,
        value: '/M',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.previousMonth,
        value: '-1M/M ~ /M',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.thisYear,
        value: '/y',
    },
    {
        type: GlobalPickerType.shortcut,
        label: locale.previousYear,
        value: '-1y/y ~ /y',
    },
];
// 拼接date和time
const computedDateTime = (date, dateFormat, times) => {
    const [t0, t1] = times || [];
    if (dateFormat && t0 && t1) {
        return [dayjs(`${dateFormat} ${t0}`), dayjs(`${dateFormat} ${t1}`)];
    }
    return [date.startOf('d'), date.endOf('d')];
};
// 解析特殊日期
export const parseSpecialTime = (value, specialDate) => {
    var _a, _b, _c;
    let dates = null;
    //  不能含有汉字
    if (value && !/[\u4e00-\u9fa5]/.test(value) && ((_a = specialDate === null || specialDate === void 0 ? void 0 : specialDate.dates) === null || _a === void 0 ? void 0 : _a.length)) {
        // 当前
        if (value.includes('%current')) {
            const current = dayjs();
            const currentFormat = current === null || current === void 0 ? void 0 : current.format('YYYY-MM-DD');
            if ((_b = specialDate === null || specialDate === void 0 ? void 0 : specialDate.dates) === null || _b === void 0 ? void 0 : _b.includes(currentFormat)) {
                dates = computedDateTime(current, currentFormat, specialDate.times);
            }
        }
        else if (value.includes('%last_d')) {
            // 上一
            for (let index = 1; index < specialDate.dates.length; index++) {
                const lastDay = dayjs().subtract(index, 'd');
                const lastDayFormat = lastDay === null || lastDay === void 0 ? void 0 : lastDay.format('YYYY-MM-DD');
                if (specialDate.dates.includes(lastDayFormat)) {
                    dates = computedDateTime(lastDay, lastDayFormat, specialDate.times);
                    break;
                }
            }
        }
        else if (value.includes('%preious_w_d')) {
            // 上周
            const preiousWeek = dayjs().subtract(7, 'd');
            const preiousWeekFormat = preiousWeek === null || preiousWeek === void 0 ? void 0 : preiousWeek.format('YYYY-MM-DD');
            if ((_c = specialDate === null || specialDate === void 0 ? void 0 : specialDate.dates) === null || _c === void 0 ? void 0 : _c.includes(preiousWeekFormat)) {
                dates = computedDateTime(preiousWeek, preiousWeekFormat, specialDate.times);
            }
        }
    }
    return dates;
};
// 通过最大区间过滤快捷选项列表
export const filterShortcutsByMaxDuration = (shortcuts, maxDuration, specialDate) => shortcuts === null || shortcuts === void 0 ? void 0 : shortcuts.filter(opt => {
    const { isEqual, isGreater } = durationText(isSpecialTime(opt.value) && (specialDate === null || specialDate === void 0 ? void 0 : specialDate.enable)
        ? parseSpecialTime(opt.value, specialDate || null)
        : parseShortcutValue(opt.value), maxDuration);
    return !isEqual && !isGreater;
});
// 特殊日期列表
export const computedSpecialList = (locale, specialDate, maxDuration) => {
    const hasMax = typeof maxDuration === 'number' && maxDuration > 0 && maxDuration !== MAX_DURATION;
    let list = [
        {
            type: GlobalPickerType.special,
            label: locale.current,
            value: '%current_d%',
        },
        {
            type: GlobalPickerType.special,
            label: locale.previousDay,
            value: '%last_d%',
        },
        {
            type: GlobalPickerType.special,
            label: locale.previousWeekDay,
            value: '%preious_w_d%',
        },
    ];
    if (hasMax) {
        list = list.filter(item => {
            const dates = parseSpecialTime(item.value, specialDate);
            if (dates) {
                const { isGreater } = durationText(dates, maxDuration);
                return !isGreater;
            }
            return false;
        });
    }
    return list.map(elem => (Object.assign(Object.assign({}, elem), { label: `${elem.label}${(specialDate === null || specialDate === void 0 ? void 0 : specialDate.name) || ''}` })));
};
// 是否为相对选项
export const isRelatveOpt = (opt) => /\/[Mdwy]/.test(opt.value);
// 是否为特殊日期选项
export const isSpecialOpt = (opt) => isSpecialTime(opt.value);
// 是否为最近选项
export const isRecentOpt = (opt) => !(isRelatveOpt(opt) || isSpecialOpt(opt));
// 是否在特殊日期内
export function isInSpecial(currentDate, specialDate) {
    var _a;
    const format = currentDate.format('YYYY-MM-DD');
    if (specialDate && specialDate.dates && specialDate.dates.length) {
        return (_a = specialDate === null || specialDate === void 0 ? void 0 : specialDate.dates) === null || _a === void 0 ? void 0 : _a.includes(format);
    }
    return false;
}
